import type { IPublicClientApplication } from '@azure/msal-browser';
import { apiRequest } from '../config/authConfig';
import { ESQUEMA, instalarPuente } from './puenteGdGo';

// =============================================================================
// La simulación del puente con GdGO! (#326, punto 6 del contrato): en STG, con ?embebido=1&simular=1 y solo donde el
// despliegue la enciende, la página hace de GdGO!. Pide el token con la sesión de Entra del navegador (la misma que usa la
// web) y lo entrega por window.gescomAux.recibirToken, y en vez de navegar a gdgo-bridge:// lo anuncia en la página.
// Nunca registra el token.
// =============================================================================

/** El evento con que la simulación anuncia lo que GdGO! recibiría (el detalle es la URL gdgo-bridge://). */
export const EVENTO_SIMULADO = 'gdgo-simulado';

export const instalarSimulador = (msal: IPublicClientApplication): void => {
  instalarPuente({
    navegar: (url) => {
      window.dispatchEvent(new CustomEvent(EVENTO_SIMULADO, { detail: url }));
      if (url === `${ESQUEMA}pide-token`) {
        void entregarToken(msal);
      }
    },
  });
};

// Como haría GdGO!: un token para la API con el mismo ámbito que la web; sin sesión, el inicio de sesión del navegador.
const entregarToken = async (msal: IPublicClientApplication): Promise<void> => {
  try {
    await msal.initialize();
    const cuenta = msal.getAllAccounts()[0] ?? (await msal.loginPopup(apiRequest)).account;
    const { accessToken } = await msal.acquireTokenSilent({ ...apiRequest, account: cuenta });
    window.gescomAux?.recibirToken(accessToken);
  } catch {
    // Sin token: la página mostrará, a los 10 s, el mismo error que dentro de GdGO!.
  }
};
